// Mock data for Keto Ambrosia site

export const siteInfo = {
  brand: "Keto Ambrosia",
  trademark: "\u2122",
  tagline: "Eat Keto - Get Fit",
  phone: "+91 98408 58201",
  phoneRaw: "+919840858201",
  email: "lakshmisv@ketoambrosia.com",
  address: "No.24 Salaiyar Street, R.A.Puram, Mandaveli, Chennai",
  facebook: "https://www.facebook.com/ketoambrosia",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Menus", path: "/menus" },
  { label: "Plans & Pricing", path: "/plans" },
  { label: "What is Keto", path: "/what-is-keto" },
];

export const heroImages = {
  topBoard:
    "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1800&q=80",
  aboutSpread:
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1800&q=80",
};

export const menuItems = [
  {
    id: "m1",
    name: "Cauli Fried Rice",
    category: "Mains",
    description: "Cauliflower-based fried rice tossed with eggs, herbs and keto seasonings.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 150,
    image: "https://images.pexels.com/photos/32655065/pexels-photo-32655065.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m2",
    name: "Chilli Paneer",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 220,
    image: "https://images.pexels.com/photos/28445829/pexels-photo-28445829.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m3",
    name: "Dosas (4 nos)",
    category: "Breakfast",
    description: "Crispy low-carb dosa made with keto-friendly flour, served with chutney.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 240,
    image: "https://images.pexels.com/photos/20422123/pexels-photo-20422123.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m4",
    name: "Mushroom Masala",
    category: "Mains",
    description: "A satisfying, macro-balanced keto main course.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 150,
    image: "https://images.pexels.com/photos/35041663/pexels-photo-35041663.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m5",
    name: "Roasted Bell Pepper and Zucchini Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 200,
    image: "https://images.pexels.com/photos/35695377/pexels-photo-35695377.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m6",
    name: "Manchurian Balls",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 200,
    image: "https://images.pexels.com/photos/28674530/pexels-photo-28674530.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m7",
    name: "Keto Rotis",
    category: "Sides",
    description: "Soft, low-carb rotis made with almond and coconut flour.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 40,
    image: "https://images.pexels.com/photos/37420999/pexels-photo-37420999.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m8",
    name: "Paneer Makhanwala",
    category: "Mains",
    description: "Soft paneer in a luscious keto gravy - North-Indian comfort, reimagined.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/11188417/pexels-photo-11188417.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m9",
    name: "Keto Chicken Biryani",
    category: "Mains",
    description: "Aromatic keto biryani built on cauliflower rice with rich spice layers.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/9609860/pexels-photo-9609860.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m10",
    name: "Keto Cabbage Dosa (3 nos)",
    category: "Breakfast",
    description: "Crispy low-carb dosa made with keto-friendly flour, served with chutney.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/20422121/pexels-photo-20422121.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m11",
    name: "Egg Masala",
    category: "Breakfast",
    description: "Spiced eggs cooked in aromatic Indian masala.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/8625813/pexels-photo-8625813.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m12",
    name: "Chicken Steak with Mushroom Sauce and Sauted Keto Veggies",
    category: "Sides",
    description: "A simple, clean side to round out your keto plate.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 320,
    image: "https://images.pexels.com/photos/28321266/pexels-photo-28321266.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m13",
    name: "Cheesy 3 Eggs Omelette",
    category: "Breakfast",
    description: "Fluffy egg omelette folded with cheese and herbs.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/26161037/pexels-photo-26161037.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m14",
    name: "Strawberry Almond Milkshake",
    category: "Beverages",
    description: "Fresh strawberries blended with almond milk and cream.",
    macros: { kcal: 260, fat: 22, protein: 8, net_carbs: 7 },
    price: 200,
    image: "https://images.pexels.com/photos/28525197/pexels-photo-28525197.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m15",
    name: "Cauli Egg Fried Rice",
    category: "Mains",
    description: "Cauliflower-based fried rice tossed with eggs, herbs and keto seasonings.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/10695966/pexels-photo-10695966.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m16",
    name: "Butter Garlic Prawns",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/16845598/pexels-photo-16845598.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m17",
    name: "Keto Bread Omelette",
    category: "Breakfast",
    description: "Fluffy egg omelette folded with cheese and herbs.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/11654228/pexels-photo-11654228.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m18",
    name: "Avocado Milkshake",
    category: "Beverages",
    description: "Creamy avocado milkshake sweetened with stevia - rich in healthy fats.",
    macros: { kcal: 260, fat: 22, protein: 8, net_carbs: 7 },
    price: 180,
    image: "https://images.pexels.com/photos/7429595/pexels-photo-7429595.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m19",
    name: "Keto Chicken and Mushroom Casserole",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 240,
    image: "https://images.pexels.com/photos/16699418/pexels-photo-16699418.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m20",
    name: "Sauted Keto Veggies",
    category: "Sides",
    description: "A simple, clean side to round out your keto plate.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 120,
    image: "https://images.pexels.com/photos/6050723/pexels-photo-6050723.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m21",
    name: "Keto Cheese Garlic Bread",
    category: "Sides",
    description: "Buttery keto bread topped with garlic, herbs and melted cheese.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 220,
    image: "https://images.pexels.com/photos/13062441/pexels-photo-13062441.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m22",
    name: "Keto Pumpkin Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/9124024/pexels-photo-9124024.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m23",
    name: "Cauliflower Ghee Rice with Brinjal Drumstick Gravy & Okra Cheesy Masala",
    category: "Mains",
    description: "Cauliflower-based fried rice tossed with eggs, herbs and keto seasonings.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/35267286/pexels-photo-35267286.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m24",
    name: "Keto Mushroom Pocket and Sauted Veggies",
    category: "Mains",
    description: "A satisfying, macro-balanced keto main course.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 275,
    image: "https://images.pexels.com/photos/10359397/pexels-photo-10359397.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m25",
    name: "Keto Butter Chicken",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/20408442/pexels-photo-20408442.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m26",
    name: "Fish in Lemon Butter Sauce with Cauliflower Mash",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 350,
    image: "https://images.pexels.com/photos/27612525/pexels-photo-27612525.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m27",
    name: "Cauli Veg Fried Rice with Keto Chilli Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 320,
    image: "https://images.pexels.com/photos/7986352/pexels-photo-7986352.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m28",
    name: "Creamy Mushroom Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/5175536/pexels-photo-5175536.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m29",
    name: "Scrambled Eggs",
    category: "Breakfast",
    description: "Soft, buttery scrambled eggs cooked to perfection.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 120,
    image: "https://images.pexels.com/photos/14415378/pexels-photo-14415378.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m30",
    name: "Prawns Masala",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/3622477/pexels-photo-3622477.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m31",
    name: "Mixed Keto Vegetable Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 160,
    image: "https://images.pexels.com/photos/6646157/pexels-photo-6646157.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m32",
    name: "Cheese Crackers",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 140,
    image: "https://images.pexels.com/photos/9592498/pexels-photo-9592498.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m33",
    name: "Zucchini Fettuccine Casserole",
    category: "Mains",
    description: "Zucchini noodles in a creamy parmesan sauce - all the flavour, none of the carbs.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 260,
    image: "https://images.pexels.com/photos/10802305/pexels-photo-10802305.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m34",
    name: "Cabbage Dumplings Stuffed with Paneer and Peppers",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 260,
    image: "https://images.pexels.com/photos/35041652/pexels-photo-35041652.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m35",
    name: "Chicken and Broccoli Cheese Bake",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 320,
    image: "https://images.pexels.com/photos/806357/pexels-photo-806357.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m36",
    name: "Mutton Bone Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 260,
    image: "https://images.pexels.com/photos/18852561/pexels-photo-18852561.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m37",
    name: "Stuffed Zucchini",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/36865407/pexels-photo-36865407.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m38",
    name: "Keto Prawns Biryani with Greek Yogurt Onion Raita",
    category: "Mains",
    description: "Aromatic keto biryani built on cauliflower rice with rich spice layers.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 320,
    image: "https://images.pexels.com/photos/28674660/pexels-photo-28674660.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m39",
    name: "Keto Cabbage Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/12955891/pexels-photo-12955891.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m40",
    name: "Keto Chicken Curry",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/35629938/pexels-photo-35629938.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m41",
    name: "Keto Eggplant Involtini",
    category: "Mains",
    description: "A satisfying, macro-balanced keto main course.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/19732411/pexels-photo-19732411.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m42",
    name: "Celery with Spinach Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 160,
    image: "https://images.pexels.com/photos/34314731/pexels-photo-34314731.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m43",
    name: "Stuffed Mushrooms",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 180,
    image: "https://images.pexels.com/photos/5950435/pexels-photo-5950435.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m44",
    name: "Stuffed Chicken Breast",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 340,
    image: "https://images.pexels.com/photos/5769376/pexels-photo-5769376.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m45",
    name: "Broccoli Soup and Paneer",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/5639476/pexels-photo-5639476.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m46",
    name: "Stuffed Capsicum",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 220,
    image: "https://images.pexels.com/photos/15747862/pexels-photo-15747862.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m47",
    name: "Keto Chicken Tikka",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 320,
    image: "https://images.pexels.com/photos/29173114/pexels-photo-29173114.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m48",
    name: "Spicy Keto Butter Garlic Prawns",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/7111475/pexels-photo-7111475.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m49",
    name: "Sauted Keto Veggies with Salad Dressing",
    category: "Sides",
    description: "A simple, clean side to round out your keto plate.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 180,
    image: "https://images.pexels.com/photos/9219081/pexels-photo-9219081.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m50",
    name: "Keto Creamy Chicken",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 300,
    image: "https://images.pexels.com/photos/16845749/pexels-photo-16845749.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m51",
    name: "Cauliflower Mac and Cheese",
    category: "Mains",
    description: "A satisfying, macro-balanced keto main course.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/10993148/pexels-photo-10993148.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m52",
    name: "Cream of Zucchini Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/13788770/pexels-photo-13788770.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m53",
    name: "Paneer Bites",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 160,
    image: "https://images.pexels.com/photos/20395267/pexels-photo-20395267.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m54",
    name: "Keto Mushroom Casserole",
    category: "Mains",
    description: "A hearty oven-baked dish layered with vegetables, cheese and keto goodness.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/32039641/pexels-photo-32039641.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m55",
    name: "Cauliflower Veg Fried Rice",
    category: "Mains",
    description: "Cauliflower-based fried rice tossed with eggs, herbs and keto seasonings.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/7986367/pexels-photo-7986367.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m56",
    name: "Pepper Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 280,
    image: "https://images.pexels.com/photos/9167470/pexels-photo-9167470.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m57",
    name: "Spicy Chicken Steak with Cauliflower Mash",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 340,
    image: "https://images.pexels.com/photos/37575747/pexels-photo-37575747.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m58",
    name: "Pumpkin and Zucchini Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 200,
    image: "https://images.pexels.com/photos/29172200/pexels-photo-29172200.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m59",
    name: "Masala Fish Tikka",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 360,
    image: "https://images.pexels.com/photos/9646846/pexels-photo-9646846.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m60",
    name: "Keto Cream of Chicken Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/10172749/pexels-photo-10172749.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m61",
    name: "Prawn Curry",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/9609841/pexels-photo-9609841.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m62",
    name: "Keto Tomato Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 160,
    image: "https://images.pexels.com/photos/3832337/pexels-photo-3832337.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m63",
    name: "Masala Boiled Eggs",
    category: "Breakfast",
    description: "Spiced eggs cooked in aromatic Indian masala.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 140,
    image: "https://images.pexels.com/photos/36999141/pexels-photo-36999141.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m64",
    name: "Zucchini Noodles with Creamy Mushrooms",
    category: "Mains",
    description: "Zucchini noodles in a creamy parmesan sauce - all the flavour, none of the carbs.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/110814/pexels-photo-110814.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m65",
    name: "Keto Spring Onion Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/8949043/pexels-photo-8949043.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m66",
    name: "Gongura Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 300,
    image: "https://images.pexels.com/photos/35532821/pexels-photo-35532821.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m67",
    name: "Cauliflower, Zucchini and Celery Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/4776487/pexels-photo-4776487.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m68",
    name: "Keto Aubergine Chicken Lasagna",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 320,
    image: "https://images.pexels.com/photos/36854696/pexels-photo-36854696.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m69",
    name: "Mushrooms with Almond Soup and Sauted Keto Veggies",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 240,
    image: "https://images.pexels.com/photos/34227768/pexels-photo-34227768.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m70",
    name: "Keto Cheesy Prawn Risotto",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 320,
    image: "https://images.pexels.com/photos/31779537/pexels-photo-31779537.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m71",
    name: "Fish Cutlets",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 375,
    image: "https://images.pexels.com/photos/34636425/pexels-photo-34636425.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m72",
    name: "Broccoli with Zucchini Casserole",
    category: "Mains",
    description: "A hearty oven-baked dish layered with vegetables, cheese and keto goodness.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 240,
    image: "https://images.pexels.com/photos/4768954/pexels-photo-4768954.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m73",
    name: "Bell Peppers and Zucchini Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 200,
    image: "https://images.pexels.com/photos/6166796/pexels-photo-6166796.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m74",
    name: "Chicken Curry",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/9792458/pexels-photo-9792458.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m75",
    name: "Chicken Pepper Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 260,
    image: "https://images.pexels.com/photos/5690385/pexels-photo-5690385.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m76",
    name: "Paneer Pockets Mini",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 120,
    image: "https://images.pexels.com/photos/8585763/pexels-photo-8585763.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m77",
    name: "Sauted Mushrooms",
    category: "Sides",
    description: "A simple, clean side to round out your keto plate.",
    macros: { kcal: 180, fat: 14, protein: 6, net_carbs: 4 },
    price: 120,
    image: "https://images.pexels.com/photos/29935504/pexels-photo-29935504.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m78",
    name: "Spring Onion Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/8054756/pexels-photo-8054756.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m79",
    name: "Chicken and Veggies Clear Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 260,
    image: "https://images.pexels.com/photos/32655229/pexels-photo-32655229.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m80",
    name: "Cauliflower Egg Fried Rice",
    category: "Mains",
    description: "Cauliflower-based fried rice tossed with eggs, herbs and keto seasonings.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/2116095/pexels-photo-2116095.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m81",
    name: "Schezwan Chilli Chicken",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 320,
    image: "https://images.pexels.com/photos/30604610/pexels-photo-30604610.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m82",
    name: "Fish Fillet in Garlic Butter Sauce",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 360,
    image: "https://images.pexels.com/photos/20408446/pexels-photo-20408446.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m83",
    name: "Keto Cream of Mushroom Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/5950429/pexels-photo-5950429.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m84",
    name: "Sauted Paneer Bites",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 120,
    image: "https://images.pexels.com/photos/9609837/pexels-photo-9609837.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m85",
    name: "Mutton Pepper Semi Gravy",
    category: "Mains",
    description: "A satisfying, macro-balanced keto main course.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 340,
    image: "https://images.pexels.com/photos/9609846/pexels-photo-9609846.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m86",
    name: "Keto Pumpkin and Zucchini Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 200,
    image: "https://images.pexels.com/photos/5662190/pexels-photo-5662190.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m87",
    name: "Cheesy Mushrooms",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 120,
    image: "https://images.pexels.com/photos/8023867/pexels-photo-8023867.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m88",
    name: "Keto Prawn Zucchini Alfredo Pasta",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 360,
    image: "https://images.pexels.com/photos/11220208/pexels-photo-11220208.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m89",
    name: "Keto Palak Paneer",
    category: "Mains",
    description: "Soft paneer in a luscious keto gravy - North-Indian comfort, reimagined.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/31249589/pexels-photo-31249589.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m90",
    name: "Keto Boneless Garlic Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 260,
    image: "https://images.pexels.com/photos/13065207/pexels-photo-13065207.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m91",
    name: "Roasted Bell Peppers with Mushroom Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 200,
    image: "https://images.pexels.com/photos/16336074/pexels-photo-16336074.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m92",
    name: "Butter Scrambled Eggs",
    category: "Breakfast",
    description: "Soft, buttery scrambled eggs cooked to perfection.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 100,
    image: "https://images.pexels.com/photos/13238607/pexels-photo-13238607.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m93",
    name: "Roasted Pumpkin Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/10110914/pexels-photo-10110914.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m94",
    name: "Chicken Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/32655226/pexels-photo-32655226.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m95",
    name: "Chilli Garlic Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 280,
    image: "https://images.pexels.com/photos/15682894/pexels-photo-15682894.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m96",
    name: "Fish Fillet with Lemon Butter Sauce",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 390,
    image: "https://images.pexels.com/photos/26586587/pexels-photo-26586587.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m97",
    name: "Paneer Makhni",
    category: "Mains",
    description: "Soft paneer in a luscious keto gravy - North-Indian comfort, reimagined.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 140,
    image: "https://images.pexels.com/photos/9609838/pexels-photo-9609838.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m98",
    name: "Cream of Chicken Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 220,
    image: "https://images.pexels.com/photos/29075346/pexels-photo-29075346.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m99",
    name: "Broccoli and Zucchini Casserole",
    category: "Mains",
    description: "A hearty oven-baked dish layered with vegetables, cheese and keto goodness.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 240,
    image: "https://images.pexels.com/photos/4768967/pexels-photo-4768967.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m100",
    name: "Chicken with Broccoli Casserole",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 280,
    image: "https://images.pexels.com/photos/4768966/pexels-photo-4768966.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m101",
    name: "Keto Bell Pepper Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/6262228/pexels-photo-6262228.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m102",
    name: "Chilli Prawns",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 290,
    image: "https://images.pexels.com/photos/13319172/pexels-photo-13319172.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m103",
    name: "Keto Celery Soup",
    category: "Soups",
    description: "Slow-simmered, low-carb soup made with fresh seasonal vegetables and herbs.",
    macros: { kcal: 220, fat: 16, protein: 10, net_carbs: 6 },
    price: 180,
    image: "https://images.pexels.com/photos/15108369/pexels-photo-15108369.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m104",
    name: "Fish Fillet in Lemon Butter Sauce",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 365,
    image: "https://images.pexels.com/photos/15059689/pexels-photo-15059689.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m105",
    name: "Keto Chilli Chicken Dry",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 260,
    image: "https://images.pexels.com/photos/5339082/pexels-photo-5339082.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m106",
    name: "Chicken Steak in Mushroom Sauce",
    category: "Mains",
    description: "Tender chicken in a creamy, low-carb gravy. Hearty and satisfying.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 290,
    image: "https://images.pexels.com/photos/36734922/pexels-photo-36734922.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m107",
    name: "Keto Fish Fillet in Lemon Garlic Butter Sauce",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 390,
    image: "https://images.pexels.com/photos/16134559/pexels-photo-16134559.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m108",
    name: "Boneless Pepper Chicken Dry with Sauted Veggies",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 325,
    image: "https://images.pexels.com/photos/20408436/pexels-photo-20408436.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m109",
    name: "Keto Dosa (without egg)",
    category: "Breakfast",
    description: "Crispy low-carb dosa made with keto-friendly flour, served with chutney.",
    macros: { kcal: 380, fat: 30, protein: 20, net_carbs: 5 },
    price: 130,
    image: "https://images.pexels.com/photos/20422133/pexels-photo-20422133.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m110",
    name: "Keto Chilli Paneer",
    category: "Starters",
    description: "Bold, flavour-packed bites cooked in keto-friendly fats and spices.",
    macros: { kcal: 340, fat: 26, protein: 22, net_carbs: 5 },
    price: 240,
    image: "https://images.pexels.com/photos/35779075/pexels-photo-35779075.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
  {
    id: "m111",
    name: "Zucchini Alfredo Pasta with Prawns",
    category: "Mains",
    description: "Fresh seafood cooked in a rich keto-friendly sauce.",
    macros: { kcal: 520, fat: 38, protein: 36, net_carbs: 6 },
    price: 360,
    image: "https://images.pexels.com/photos/5639532/pexels-photo-5639532.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  },
];

export const plans = [
  {
    id: "p1",
    name: "Starter",
    duration: "Weekly",
    price: 4999,
    badge: null,
    features: [
      "5 days of meals",
      "2 meals per day (lunch + dinner)",
      "Weekly menu rotation",
      "Free delivery in R.A.Puram",
      "WhatsApp menu updates",
    ],
  },
  {
    id: "p2",
    name: "Transform",
    duration: "Monthly",
    price: 17999,
    badge: "Most Popular",
    features: [
      "26 days of meals",
      "3 meals per day (B + L + D)",
      "Personalised macro targets",
      "Free delivery across Chennai",
      "1:1 monthly nutrition call",
      "Custom recipe swaps",
    ],
  },
  {
    id: "p3",
    name: "Family",
    duration: "Monthly",
    price: 32999,
    badge: null,
    features: [
      "Meals for 2 adults",
      "3 meals per day each",
      "Shared family menu planning",
      "Priority delivery slots",
      "Dedicated nutrition coach",
      "Free dessert add-ons",
    ],
  },
];

export const ketoFacts = [
  {
    title: "What is the Keto Diet?",
    body:
      "A ketogenic diet is a high-fat, moderate-protein, very-low-carbohydrate eating pattern. By keeping daily net carbs typically below 20-30g, the body shifts from burning glucose to burning fat for fuel, a state known as nutritional ketosis.",
  },
  {
    title: "How does it work?",
    body:
      "When carbohydrates are restricted, insulin levels drop and the liver begins converting fatty acids into ketones. Ketones become the primary fuel source for your brain and muscles, often leading to steady energy and reduced cravings.",
  },
  {
    title: "What can you eat?",
    body:
      "Healthy fats (ghee, butter, olive oil, coconut), quality proteins (eggs, fish, paneer, poultry, mutton), above-ground vegetables, nuts and seeds, full-fat dairy, and a small amount of berries.",
  },
  {
    title: "What to avoid?",
    body:
      "Sugar, grains (rice, wheat, oats), most fruits, starchy vegetables (potato, tapioca), legumes, and ultra-processed foods. We design every Keto Ambrosia meal to keep you comfortably under your daily carb target.",
  },
];

export const benefits = [
  {
    title: "Sustained Fat Loss",
    body: "Burn stored body fat as fuel without the energy crashes of crash diets.",
  },
  {
    title: "Steady Energy",
    body: "No more 3 PM slumps - ketones deliver smooth, all-day fuel.",
  },
  {
    title: "Sharper Focus",
    body: "Many of our customers report clearer thinking and better mood.",
  },
  {
    title: "Appetite Control",
    body: "Healthy fats and protein keep you full for longer, naturally.",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Anitha R.",
    location: "Mylapore, Chennai",
    quote:
      "I lost 8 kg in 3 months without feeling hungry once. Keto Ambrosia made the switch effortless - meals just show up, hot and delicious.",
  },
  {
    id: "t2",
    name: "Karthik S.",
    location: "Adyar, Chennai",
    quote:
      "As a working dad, I had no time to plan keto meals. Their Transform plan keeps my whole week sorted and my energy levels are amazing.",
  },
  {
    id: "t3",
    name: "Priya M.",
    location: "R.A.Puram",
    quote:
      "The food tastes like home-cooked Indian meals - just without the rice. My family can\u2019t believe these are keto.",
  },
];

export const heroBoardImages = [
  "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=900&q=80",
  "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=900&q=80",
  "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=900&q=80",
];
